/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://5uadtau7a5cbbnp6wcdjipsixi.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-deg7t64adzhezadp2rgkdwngv4",
    "aws_cognito_identity_pool_id": "us-east-2:a3dc7808-eaa5-47f6-b1c8-a8ebfc60d37b",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_b1n63kohk",
    "aws_user_pools_web_client_id": "4simvchommjfjv3lgbg1tf4ms8",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
